import useAppContext from '@groupefungo/react-apollo.core/app/UseContext';

export default () => {
  const { gql } = useAppContext();

  // eslint-disable-next-line import/prefer-default-export
  const MeasurementFragment = gql`
fragment MeasurementFragment on Measurement {
  id
  age
  braSize
  bust
  height
  highHip
  hollowToWaist
  lowHip
  notes
  underBust
  waist
  weight
  document {
    id
    filename
    url
  }
}
`;

  return {
    MeasurementFragment,
  };
};
